<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<p class="chapterTitle1"><span class="bold">Contents</span></p>
<p class="paraNoIndent"><a href="#/06a_Fouldeeds_introduction"><span class="bold">Introduction </span></a></p>
<p class="paraNoIndent"><a href="#/07_Fouldeeds_ack"><span class="bold">Acknowledgements</span></a></p>
<table class="table1">
<tbody><tr valign="top">
<td><a href="#/08_Fouldeeds_ch01"><span class="bold">Chapter 1</span></a></td>
<td>   </td>
<td><a href="#/08_Fouldeeds_ch01">Foul Deeds and Murder through the Ages, 1236–1984</a></td>
</tr>
<tr valign="top">
<td><span href="#/09_Fouldeeds_ch02" title="Link target outside of Sample"><span class="bold">Chapter 2</span></span></td>
<td>   </td>
<td><span href="#/09_Fouldeeds_ch02" title="Link target outside of Sample">Gunpowder, Treason and Plot, 1605</span></td>
</tr>
<tr valign="top">
<td><span href="#/10_Fouldeeds_ch03" title="Link target outside of Sample"><span class="bold">Chapter 3</span></span></td>
<td>   </td>
<td><span href="#/10_Fouldeeds_ch03" title="Link target outside of Sample">Execution of Charles I, Whitehall, 1649</span></td>
</tr>
<tr valign="top">
<td><span href="#/11_Fouldeeds_ch04" title="Link target outside of Sample"><span class="bold">Chapter 4</span></span></td>
<td>   </td>
<td><span href="#/11_Fouldeeds_ch04" title="Link target outside of Sample">Claude Duval, the Dashing Highwayman, 1670</span></td>
</tr>
<tr valign="top">
<td><span href="#/12_Fouldeeds_ch05" title="Link target outside of Sample"><span class="bold">Chapter 5</span></span></td>
<td>   </td>
<td><span href="#/12_Fouldeeds_ch05" title="Link target outside of Sample">The Burning of Catherine Hayes, 1726</span></td>
</tr>
<tr valign="top">
<td><span href="#/13_Fouldeeds_ch06" title="Link target outside of Sample"><span class="bold">Chapter 6</span></span></td>
<td>   </td>
<td><span href="#/13_Fouldeeds_ch06" title="Link target outside of Sample">Murdered by a Poet, 1727</span></td>
</tr>
<tr valign="top">
<td><span href="#/14_Fouldeeds_ch07" title="Link target outside of Sample"><span class="bold">Chapter 7</span></span></td>
<td>   </td>
<td><span href="#/14_Fouldeeds_ch07" title="Link target outside of Sample">Killed in a Tiff over a Wig, 1735</span></td>
</tr>
<tr valign="top">
<td><span href="#/15_Fouldeeds_ch08" title="Link target outside of Sample"><span class="bold">Chapter 8</span></span></td>
<td>   </td>
<td><span href="#/15_Fouldeeds_ch08" title="Link target outside of Sample">Shot by an Amorous Clergyman, 1779</span></td>
</tr>
<tr valign="top">
<td><span href="#/16_Fouldeeds_ch09" title="Link target outside of Sample"><span class="bold">Chapter 9</span></span></td>
<td>   </td>
<td><span href="#/16_Fouldeeds_ch09" title="Link target outside of Sample">Assassination of the Prime Minister, 1812</span></td>
</tr>
<tr valign="top">
<td><span href="#/17_Fouldeeds_ch10" title="Link target outside of Sample"><span class="bold">Chapter 10</span></span></td>
<td>   </td>
<td><span href="#/17_Fouldeeds_ch10" title="Link target outside of Sample">The Cato Street Conspiracy, 1820</span></td>
</tr>
<tr valign="top">
<td><span href="#/18_Fouldeeds_ch11" title="Link target outside of Sample"><span class="bold">Chapter 11</span></span></td>
<td>   </td>
<td><span href="#/18_Fouldeeds_ch11" title="Link target outside of Sample">Murder at the Adelphi, 1897</span></td>
</tr>
<tr valign="top">
<td><span href="#/19_Fouldeeds_ch12" title="Link target outside of Sample"><span class="bold">Chapter 12</span></span></td>
<td>   </td>
<td><span href="#/19_Fouldeeds_ch12" title="Link target outside of Sample">The Strange Disappearance of Victor Grayson, 1920</span></td>
</tr>
<tr valign="top">
<td><span href="#/20_Fouldeeds_ch13" title="Link target outside of Sample"><span class="bold">Chapter 13</span></span></td>
<td>   </td>
<td><span href="#/20_Fouldeeds_ch13" title="Link target outside of Sample">Murder at the <em class="italic">Savoy Hotel</em>, 1923</span></td>
</tr>
<tr valign="top">
<td><span href="#/21_Fouldeeds_ch14" title="Link target outside of Sample"><span class="bold">Chapter 14</span></span></td>
<td>   </td>
<td><span href="#/21_Fouldeeds_ch14" title="Link target outside of Sample">The Charing Cross Trunk Murder, 1927</span></td>
</tr>
</tbody></table>
<p class="paraNoIndent"><span href="#/22_Fouldeeds_Sources" title="Link target outside of Sample"><span class="bold">Sources and Further Reading </span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fouldeeds_contents.vue?5790578d